import {createStackNavigator} from '@react-navigation/stack';
import React from 'react';
import {
  Login,
  OtpVerification,
  ResetPasswordConfirmation,
  ResetPasswordConfirmationSuccess,
} from '../scenes/Login';
import ResetPassword from '../scenes/ResetPassword';

const Stack = createStackNavigator();

export const LoginStackNavigator = () => {
  return (
    <Stack.Navigator
      initialRouteName="auth"
      screenOptions={{
        headerMode: 'none',
        headerTintColor: 'white',
        headerStyle: {backgroundColor: 'tomato'},
      }}>
      <Stack.Screen name="auth" component={Login} />
      <Stack.Screen name="otpVerification" component={OtpVerification} />
      <Stack.Screen name="resetPassword" component={ResetPassword} />
      <Stack.Screen
        name="resetPasswordConfirmation"
        component={ResetPasswordConfirmation}
      />
      <Stack.Screen
        name="resetPasswordConfirmationSuccess"
        component={ResetPasswordConfirmationSuccess}
        options={{headerLeft: null, gestureEnabled: false}}
      />
    </Stack.Navigator>
  );
};
